export * from './externals';

export const DISPLAY_AD_ZONES = Object.freeze({
  NOW_PLAYING: 'NOW_PLAYING',
  BACKSTAGE: 'BACKSTAGE',
} as const);

export const REWARD_URLS = Object.freeze({
  FLEX_REPLAY: 'FLEX_REPLAY',
  FLEX_SKIP: 'FLEX_SKIP',
  FLEX_THUMBS_DOWN: 'FLEX_THUMBS_DOWN',
  SLOPA: 'SLOPA',
  SLOPA_NO_AVAILS: 'SLOPA_NO_AVAILS',
} as const);
